import React from 'react';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {XStack, Button, YStack, View, Tooltip} from '@medad-sep/core';
import {MenuItem} from '@shared/models/MenuItem';

interface Props {
  menuItems: MenuItem[];
  placement?: 'side' | 'bottom';
}

export function AppSideBar({menuItems, placement = 'side'}: Props): JSX.Element {
  const location = useLocation();
  const {t} = useTranslation();
  const isBottomPlacement = placement === 'bottom';

  if (isBottomPlacement) {
    return (
      <XStack
        role="navigation"
        backgroundColor="$brand-700"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        gap="$4">
        {menuItems?.map(({route, icon}) => {
          return (
            <Link
              key={route}
              to={route}
              style={{
                flex: 1,
                textDecoration: 'none',
              }}>
              <YStack
                alignItems="center"
                paddingVertical="$3"
                backgroundColor={location.pathname === route ? '$lightWhite' : '$transparent'}>
                <Button unstyled prefix={icon} color="$white" />
              </YStack>
            </Link>
          );
        })}
      </XStack>
    );
  }

  return (
    <XStack
      role="navigation"
      aria-label={t('navigation.adminMenu')}
      paddingBottom="$1"
      width="$5"
      paddingVertical="$0"
      backgroundColor="$brand-700"
      justifyContent="space-between"
      alignItems="flex-start"
      height="unset">
      <YStack width="100%" justifyContent="center">
        {menuItems?.map(({route, label, icon}) => {
          return (
            <View
              height="$4.5"
              key={route}
              alignItems="center"
              justifyContent="center"
              backgroundColor={location.pathname === route ? '$lightWhite' : '$transparent'}>
              <Tooltip placement="left-start" content={label}>
                <Link to={route} style={{textDecoration: 'none'}}>
                  <Button unstyled prefix={icon} color="$white" />
                </Link>
              </Tooltip>
            </View>
          );
        })}
      </YStack>
    </XStack>
  );
}
